import React, {useCallback, useState} from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import { useClientCompaniesQueryQuery} from "../../generated/graphql";
import { GraphQlSelectId } from "./GraphQlSelectId";
import { isObject } from "../id-diff-merge";

export const ClientCompanySelect = (props) => {
    const [searchTerm,setSearchTerm] = useState('');
    const query = useClientCompaniesQueryQuery({variables:{name:searchTerm?'%'+searchTerm+'%':''}});
    const valueQuery = useClientCompaniesQueryQuery({variables:{ids:props.value}});
    const renderOptionString= useCallback((option)=>{
        if(!isObject(option)) return option;
        if(!option.id) {
            return option.sales_company??'';
        }
        return (option.sales_company?(option.sales_company + ' / '):'') + (option.accounts_company??'N/A');
    },[]);
    const changeSearchTerm = useCallback((value)=> {
        console.log('CHANGESST',value);
        setSearchTerm(value);
    },[setSearchTerm]);
    return props.valueIsId?<GraphQlSelectId {...props} queryResult={query} setSearchTerm={changeSearchTerm} valueQuery={valueQuery} renderOptionString={renderOptionString} labelField="sales_company"  />:
    <GraphQlSelect  {...props} queryResult={query} setSearchTerm={changeSearchTerm} renderOptionString={renderOptionString} labelField="sales_company"  valueQuery={valueQuery} />;
}

/*

export const ClientCompanySelect = (props) => {
    const filter = useCallback((options) => {
        return options.map((el) => {
            return {
                id: el.id,
                label: (el.sales_company?(el.sales_company + ' / '):'') + el.accounts_company
            };
        });
    }, []);
    // eslint-disable-next-line react/prop-types, react/display-name
    if(props.multi) {
        value = props.value;
    } else {
        var value = props.value ? { id: props.value.id, label: props.value.label ? props.value.label : (props.value.sales_company + ' / ' + props.value.accounts_company) } : null;
    }
    return <GenericLookup query={clientCompaniesQuery} {...props} value={value} filterOptions={filter} labelField="label" />;
}*/